import mutations from './codeStoreSimple.mutations'
import actions from './codeStoreSimple.actions'
import getters from './codeStoreSimple.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
